var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TimeDisplay',_vm._b({attrs:{"duration":_vm.timeLeft},scopedSlots:_vm._u([{key:"default",fn:function(timeData){return [_vm._t("default",null,null,timeData)]}}],null,true)},'TimeDisplay',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }